module.exports = __webpack_public_path__ + "static/media/benefits-regional.b677eb3b.png";